import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[NumberType]'
})
export class NumberOnlyDirective {
    // Allow decimal numbers. The \. is only allowed once to occur
    private regex: RegExp = new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);

    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    @Input() NumberType: string;
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

    constructor(private el: ElementRef) {
    }

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        let value: string = this.el.nativeElement.children[0].children[0].value;
        if ([8, 9, 13, 16, 17, 18, 27].indexOf(event.charCode) > -1) {
            // backspace, enter, escape, arrows  
            return true;
        } else if (event.charCode >= 48 && event.charCode <= 57) {
            // numbers  
            return true;
        } else if (event.charCode === 46 && this.NumberType === "float") {
            // dot and numpad dot
            if (value.indexOf('.') > -1) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
}